(function ($, Headroom) {
  'use strict';

  var headroom;
  var options = {
    offset: 48,
    tolerance: 12,
    classes: {
      initial: 'page-header--pinnable',
      pinned: 'page-header--pinned',
      unpinned: 'page-header--unpinned',
      top: 'page-header--top',
      notTop: 'page-header--not-top'
    }
  };

  $(document).ready(init);

  function init() {
    var pageHeader = document.querySelector('.page-header');
    if (pageHeader) {
      headroom = new Headroom(pageHeader, options);
      headroom.init();
    }
  }

})(jQuery, Headroom);
